module.exports = __webpack_public_path__ + "img/icon_pesanan_red.2a4b0446.png";